export const DEFAULT_DETAILS = {
	TITLE: 'Error',
	MESSAGE:
		'Please try again in a few minutes. If the issue continues, please reach out to your Account Executive.',
};
